import api from "./client";

export async function listWipBalances(params = {}) {
  const res = await api.get("/wip/balances", { params });
  return res.data.data.items;
}

